<div class="custom-context-menu">
    <div (click)="handleMenuItemClick('Option 1')">Option 1</div>
    <div (click)="handleMenuItemClick('Option 2')">Option 2</div>
    <!-- Add more menu items as needed -->
  </div>